import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserLocation, selectUserLocation } from '../store/signup';

export const useUserLocation = () => {
  const dispatch = useDispatch();
  const userLocation = useSelector(selectUserLocation);

  useEffect(() => {
    // undefined: never looked up in this session; null: looked up, country unknown
    if (userLocation === undefined) dispatch(getUserLocation());
  }, [dispatch, userLocation]);

  return userLocation;
};
